import Terminal from './components/Terminal';

const App = () =>
    <div>
        <Terminal />
    </div>;

export default App;
